import axios from 'axios'
import { ref } from 'vue'
import { showConsoleError } from '@/functions/errors'
import { APIS_TOPOLOGY, APIS_DASHBOARD, TIMEOUTTIME } from '@/constants/apis'
import { TYPES, STATUS, STRING_GENERAL, TOKEN } from '@/constants/labels'
import { ALARM_TYPE, EQUIPOS, GLOBAL_STATUS, OPERABILITY } from '@/interfaces/SmartLink/Equipos';

export async function getOperabilityLastDayTopology() {

  // ARREGLAR PARA RAOS TMB

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_TOPOLOGY.value.getAllOpLastDay, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: OPERABILITY[] = response.data;
      const finalObj = ref<OPERABILITY[]>([])
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {
        finalObj.value = finalData
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}


export async function getAlarmToTopology() {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_DASHBOARD.value.alarmtodash, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: ALARM_TYPE[] = response.data;
      const finalObj = ref<ALARM_TYPE[]>([])
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {
        finalObj.value = finalData
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}



export async function getCountStatusTopology() {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_TOPOLOGY.value.getAllTopoData, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: EQUIPOS[] = response.data;
      const finalObj = ref<GLOBAL_STATUS>({
        distri: { title: STRING_GENERAL.distri, ok: { cant: 0, table: [] }, alarm: { cant: 0, table: [] }, alert: { cant: 0, table: [] }, down: { cant: 0, table: [] }, totalAlar: [], totalGaug: [] },
        acceso: { title: STRING_GENERAL.access, ok: { cant: 0, table: [] }, alarm: { cant: 0, table: [] }, alert: { cant: 0, table: [] }, down: { cant: 0, table: [] }, totalAlar: [], totalGaug: [] },
        client: { title: STRING_GENERAL.client, ok: { cant: 0, table: [] }, alarm: { cant: 0, table: [] }, alert: { cant: 0, table: [] }, down: { cant: 0, table: [] }, totalAlar: [], totalGaug: [] },
      })
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {

        finalData.forEach((item: EQUIPOS) => {
          if (item.subtipo === TYPES.distri && item.status) {
            item.status.toUpperCase() === STATUS.ok ? (finalObj.value.distri.ok.cant++, finalObj.value.distri.ok.table.push(item)) : null;
            item.status.toUpperCase() === STATUS.alarm ? (finalObj.value.distri.alarm.cant++, finalObj.value.distri.alarm.table.push(item)) : null;
            item.status.toUpperCase() === STATUS.alert ? (finalObj.value.distri.alert.cant++, finalObj.value.distri.alert.table.push(item)) : null;
            item.status.toUpperCase() === STATUS.down ? (finalObj.value.distri.down.cant++, finalObj.value.distri.down.table.push(item)) : null;
          }

          if (item.subtipo === TYPES.acceso && item.status) {
            item.status.toUpperCase() === STATUS.ok ? (finalObj.value.acceso.ok.cant++, finalObj.value.acceso.ok.table.push(item)) : null;
            item.status.toUpperCase() === STATUS.alarm ? (finalObj.value.acceso.alarm.cant++, finalObj.value.acceso.alarm.table.push(item)) : null;
            item.status.toUpperCase() === STATUS.alert ? (finalObj.value.acceso.alert.cant++, finalObj.value.acceso.alert.table.push(item)) : null;
            item.status.toUpperCase() === STATUS.down ? (finalObj.value.acceso.down.cant++, finalObj.value.acceso.down.table.push(item)) : null;
          }

          if (item.subtipo === TYPES.client && item.status) {
            item.status.toUpperCase() === STATUS.ok ? (finalObj.value.client.ok.cant++, finalObj.value.client.ok.table.push(item)) : null;
            item.status.toUpperCase() === STATUS.alarm ? (finalObj.value.client.alarm.cant++, finalObj.value.client.alarm.table.push(item)) : null;
            item.status.toUpperCase() === STATUS.alert ? (finalObj.value.client.alert.cant++, finalObj.value.client.alert.table.push(item)) : null;
            item.status.toUpperCase() === STATUS.down ? (finalObj.value.client.down.cant++, finalObj.value.client.down.table.push(item)) : null;
          }
        })
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}